import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format currency in German format
export function formatCurrency(amount) {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
}

// Format date in German format
export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

// Format date for input fields (YYYY-MM-DD)
export function formatDateForInput(dateString) {
  if (!dateString) return '';
  return dateString.slice(0, 10);
}

// Get current date in ISO format
export function getCurrentDateISO() {
  return new Date().toISOString().slice(0, 10);
}

// Get year start date
export function getYearStartISO(year = new Date().getFullYear()) {
  return `${year}-01-01`;
}

// Get year end date
export function getYearEndISO(year = new Date().getFullYear()) {
  return `${year}-12-31`;
}

// Translation maps
export const COST_TYPE_LABELS = {
  grundsteuer: 'Grundsteuer',
  wasser: 'Wasserversorgung',
  abwasser: 'Entwässerung',
  heizung: 'Heizkosten',
  warmwasser: 'Warmwasserkosten',
  muell: 'Müllabfuhr',
  strassenreinigung: 'Straßenreinigung',
  gebaeudereinigung: 'Gebäudereinigung',
  gartenpflege: 'Gartenpflege',
  hausmeister: 'Hausmeisterdienste',
  beleuchtung: 'Beleuchtung',
  versicherung: 'Versicherungen',
  schornsteinfeger: 'Schornsteinfeger',
  aufzug: 'Aufzug',
  antenne: 'Antenne/Kabel',
  sonstige: 'Sonstige Betriebskosten',
};

export const DISTRIBUTION_KEY_LABELS = {
  wohnflaeche: 'Nach Wohnfläche',
  personenzahl: 'Nach Personenzahl',
  einheiten: 'Nach Einheiten',
  verbrauch: 'Nach Verbrauch',
};

export const UNIT_TYPE_LABELS = {
  wohnung: 'Wohnung',
  gewerbe: 'Gewerbeeinheit',
  stellplatz: 'Stellplatz',
  garage: 'Garage',
  lager: 'Lager',
};
